import React, { useEffect, useState } from 'react'
import Layout from '../../layouts/Layout'
import { getUserListAPI } from '../../services/api/UserAPI';
import Loader from '../components/Loader';
import { useSelector } from "react-redux";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { FaSearch } from "react-icons/fa";

import 'primereact/resources/themes/saga-blue/theme.css'; // PrimeReact Theme
import 'primereact/resources/primereact.min.css';         // PrimeReact CSS
import 'primeicons/primeicons.css';

const Index = () => {
    const [userList, setUserList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const user = useSelector((state) => state.LoginReducer.authData);

    const onGlobalFilterChange = (e) => {
        setGlobalFilterValue(e.target.value);
    };

    useEffect(() => {
        const fetchUserList = async () => {
            try {
                const token = user.data.token;
                const users = await getUserListAPI(token);
                if(users.status){
                    setUserList(users.user);
                }
            } catch (error) {
                console.error('Error fetching user list:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserList();
    }, []);

    if (loading) {
        return <Loader />;
    }
    
    return (
        <Layout title="Users">
            <div className="container table-container">
                <div className='d-flex align-items-center justify-content-end'>
                    <div className="mb-2 d-flex align-items-center custom-input-group">
                        <FaSearch className="search-icon" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" className="flex-grow-1" />
                    </div>
                </div>
                <DataTable value={userList} paginator rows={10} sortField="name" sortOrder={1} removableSort stripedRows globalFilter={globalFilterValue} rowsPerPageOptions={[10, 25, 50, 100]} emptyMessage={<span className="custom-empty-message">No records found</span>} >
                    <Column field="id" header="ID" sortable></Column>
                    <Column field="name" header="Name" sortable></Column>
                    <Column field="email" header="Email" sortable></Column>
                    <Column field="mobile" header="Mobile No." sortable></Column>
                </DataTable>
            </div>
        </Layout>
    )
}

export default Index